import { SeriesPick } from "components/SeriesPick";
import { UIPick } from "models/Models";
import { Fragment } from "react";

interface Props {
  picks: UIPick[];
  round: number;
  division: number;
  spacer?: boolean;
  onGamesChanged: (pick: UIPick, games: number) => void;
  onTeamSelected: (pick: UIPick, teamId: number) => void;
}

export const RoundSeries = (props: Props) => {

 
    return <>
      {props.picks
        .filter((c) => c.round === props.round && c.division === props.division)
        .sort((c) => -c.homeTeamSeed)
        .map((p, x) => (
          <div key={p.seriesId} className="series">
            <SeriesPick pick={p} onGamesChanged={props.onGamesChanged} onTeamSelected={props.onTeamSelected}/>
            {x == 0 && props.spacer && <div key={x} className="spacer"></div>}
          </div>
        ))}
    </>;
  
};
